import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import { getSettings } from "../../services/settings/actions";
import {
  getSingleLanguageData,
  getAllLanguages,
} from "../../services/languages/actions";
import { logoutUser } from "../../services/user/actions";
import {WEBSITE_URL} from "../../configs//website";
import apiClient from "../../services/apiClient";

const CheckVersion = (props) => {
  const [updating, setUpdating] = useState(false);
  const serverUrl = `${WEBSITE_URL}/api/version?t=${new Date().getTime()}`;


  useEffect(() => {
    apiClient.post(serverUrl).then((response) => {
      const forceNewSettingsServerVersion =
        response.data.forceNewSettingsVersion;
      const forceCacheClearServerVersion = response.data.forceCacheClearVersion;

      if (
        localStorage.getItem("forceNewSettingsVersion") === null &&
        localStorage.getItem("forceCacheClearVersion") === null
      ) {
        localStorage.setItem(
          "forceNewSettingsVersion",
          forceNewSettingsServerVersion
        );
        localStorage.setItem(
          "forceCacheClearVersion",
          forceCacheClearServerVersion
        );
      } else {
        if (
          localStorage.getItem("forceNewSettingsVersion") !==
          forceNewSettingsServerVersion
        ) {
          console.warn("Getting New Settings");
          props.getSettings();
          localStorage.setItem(
            "forceNewSettingsVersion",
            forceNewSettingsServerVersion
          );
        }

        if (
          localStorage.getItem("forceCacheClearVersion") !==
          forceCacheClearServerVersion
        ) {
          const clearLocalStorage = () => {
            return new Promise((resolve) => {
              console.warn("Clear Local Storage");
              let geoLocation = localStorage.getItem("geoLocation");
              let userSetAddress = localStorage.getItem("userSetAddress");
              let storeColor = localStorage.getItem("storeColor");
              let storeLogo = localStorage.getItem("storeLogo");
              let updatingMessage = localStorage.getItem("updatingMessage");
              let userPreferedLanguage = localStorage.getItem("userPreferedLanguage");

              localStorage.clear();

              if (geoLocation !== null) {
                localStorage.setItem("geoLocation", geoLocation);
              }
              if (userSetAddress !== null) {
                localStorage.setItem("userSetAddress", userSetAddress);
              }
              localStorage.setItem("storeColor", storeColor);
              localStorage.setItem("storeLogo", storeLogo);
              localStorage.setItem("updatingMessage", updatingMessage);
              if (userPreferedLanguage !== null) {
                localStorage.setItem(
                  "userPreferedLanguage",
                  userPreferedLanguage
                );
              }

              resolve("Completed clearLocalStorage");
            });
          };

          const clearCacheStorage = () => {
            return new Promise((resolve) => {
              console.warn("Clear Cache Storage");
              navigator.serviceWorker.getRegistrations().then(function (
                registrations
              ) {
                for (let registration of registrations) {
                  registration.unregister();
                }
              });
              if (caches) {
                caches.keys().then(function (names) {
                  for (let name of names) caches.delete(name);
                });
              }
              resolve("Completed clearCacheStorage");
            });
          };

          const fetchSettingsAndLanguage = () => {
            return new Promise((resolve) => {
              console.warn("Fetch Settings and Translations");
              props.getSettings();

              if (localStorage.getItem("userPreferedLanguage") !== null) {
                props.getSingleLanguageData(
                  localStorage.getItem("userPreferedLanguage")
                );
                resolve("Completed fetchSettingsAndLanguage");
              } else {
                props.getAllLanguages().then(async(languages) => {
                  const id = languages.payload.filter(
                    (lang) => lang.is_default === 1
                  )[0].id;
                  await props.getSingleLanguageData(id).then(() => {
                    resolve("Completed fetchSettingsAndLanguage");
                  });
                });
              }
            });
          };

          const updateClientVersion = () => {
            return new Promise((resolve) => {
              console.warn("Update Client Version");
              localStorage.setItem(
                "forceNewSettingsVersion",
                forceNewSettingsServerVersion
              );
              localStorage.setItem(
                "forceCacheClearVersion",
                forceCacheClearServerVersion
              );
              resolve("Completed updateClientVersion");
            });
          };

          const reloadBrowser = () => {
            return new Promise((resolve) => {
              setTimeout(() => {
                setUpdating(false);
                window.location.reload(true);
                resolve("Completed reloadBrowser");
              }, 3 * 1000);
            });
          };

          async function doProcess() {
            await clearLocalStorage();
            await clearCacheStorage();
            await fetchSettingsAndLanguage();
            await updateClientVersion();
            await reloadBrowser();
          }
          setUpdating(true);
          doProcess();
        }
      }
    });
  }, []);

  return (
    <React.Fragment>
      {updating && (
        <React.Fragment>
          <div className="update-full-notification">
            <span className="spin-load" />
          </div>
          <div
            className="update-full-notification"
            style={{ zIndex: 9999999999 }}
          >
            <h1 className="d-flex" style={{ marginTop: "8rem" }}>
              {localStorage.getItem("updatingMessage")}
            </h1>
          </div>
        </React.Fragment>
      )}
    </React.Fragment>
  );
};

const mapStateToProps = (state) => ({
  settings: state.settings.settings,
});

export default (connect(mapStateToProps, {
  getSettings,
  getSingleLanguageData,
  getAllLanguages,
  logoutUser,
})(CheckVersion));
